/*
 * $Id:: index.js 2020/11/11 12:46 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React from 'react';

import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import { makeStyles } from '@material-ui/core/styles';
import { t } from '../../../providers';

const useStyles = makeStyles((_theme) => ({
    tableHeader: {
        background: '#fff',
        textTransform: 'none',
        fontSize: '0.75rem',
        color: '#2E2E2E',
        fontWeight: '600',
        lineHeight: '133%',
        boxShadow: 'inset 0px -1px 0px #E2E4E9',
        '& .MuiTableSortLabel-root': {
            '&:focus-visible': {
                backgroundColor: 'rgba(209, 224, 194, 0.2)',
                outline: 'none',
                border: '2px dashed #4F7E1D',
                borderRadius: '3px',
            },
        },
    },
}));

const ApplicationsTableHeader = ({ sortBy, sortType, setSorting, headers, tableId }) => {
    const classes = useStyles();
    const sortHeader = (event, sortBy) => {
        event.preventDefault();
        setSorting(sortBy);
    };

    return (
        <TableHead>
            <TableRow>
                {headers.map((item, idx) => (
                    <TableCell
                        id={`${tableId}-col-${item.code}`}
                        key={idx}
                        align={item.align}
                        className={classes.tableHeader}
                        aria-sort={sortBy === item.code ? t(sortType.toLowerCase()) : undefined}
                        style={item && item.style ? item.style : {}}>
                        {item.sortable ? (
                            <TableSortLabel
                                id={`${tableId}-col-${item.code}-value`}
                                active={sortBy === item.code}
                                direction={sortType.toLowerCase()}
                                onClick={(event) => sortHeader(event, item.code)}>
                                {item.label}
                            </TableSortLabel>
                        ) : (
                            <span id={`${tableId}-col-${item.code}-value`}>{item.label}</span>
                        )}
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
};

export default ApplicationsTableHeader;
